


// import React, { useState, useRef, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Copy, Play, Pause, Maximize2, Download, Share2, Eye, Settings, Monitor, Smartphone, Plane, MapPin, Calendar, Camera, Star, Heart, Globe } from 'lucide-react';

// // Travel Adventure Ad Component
// const TravelAdContent = ({ isInPreview = false }) => {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [showInteraction, setShowInteraction] = useState(false);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);

//   const destinations = [
//     { name: "Santorini", country: "Greece", image: "🏝️", price: "$1,299" },
//     { name: "Tokyo", country: "Japan", image: "🗾", price: "$1,599" },
//     { name: "Bali", country: "Indonesia", image: "🌺", price: "$899" },
//     { name: "Swiss Alps", country: "Switzerland", image: "🏔️", price: "$1,899" }
//   ];

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowInteraction(true);
//     }, 2000);
//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     if (!isExpanded) {
//       const slideTimer = setInterval(() => {
//         setCurrentSlide((prev) => (prev + 1) % destinations.length);
//       }, 3000);
//       return () => clearInterval(slideTimer);
//     }
//   }, [isExpanded, destinations.length]);

//   const handleExpand = () => {
//     setIsAnimating(true);
//     setTimeout(() => {
//       setIsExpanded(true);
//       setIsAnimating(false);
//     }, 500);
//   };

//   const closeAd = () => {
//     setIsExpanded(false);
//     setShowInteraction(false);
//     setTimeout(() => {
//       setShowInteraction(true);
//     }, 2000);
//   };

//   return (
//     <div className=" px-6 w-full h-full bg-gradient-to-br from-sky-400 via-blue-500 to-indigo-600 relative overflow-hidden">
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0">
//         {/* Floating Clouds */}
//         {[...Array(isInPreview ? 3 : 6)].map((_, i) => (
//           <div
//             key={i}
//             style={{
//               width: `${60 + Math.random() * 80}px`,
//               height: `${30 + Math.random() * 40}px`,
//               left: `${Math.random() * 100}%`,
//               top: `${Math.random() * 100}%`,
//               animationDelay: `${Math.random() * 3}s`,
//               animationDuration: `${3 + Math.random() * 2}s`,
//               transform: `translateX(${Math.sin(i) * 20}px)`
//             }}
//           />
//         ))}
        
//         {/* Twinkling Stars */}
//         {[...Array(isInPreview ? 8 : 15)].map((_, i) => (
//           <div
//             key={i}
//             className="absolute w-1 h-1 bg-white rounded-full animate-ping "
//             style={{
//               left: `${Math.random() * 100}%`,
//               top: `${Math.random() * 100}%`,
//               animationDelay: `${Math.random() * 2}s`,
//               animationDuration: `${1 + Math.random() * 2}s`
//             }}
//           />
//         ))}
//       </div>

//       {!isExpanded ? (
//         <div className="relative h-full flex items-center justify-center">
//           {/* Compact Travel Ad */}
//           <div 
//             className={`relative cursor-pointer transform transition-all duration-700 ${
//               showInteraction ? 'hover:scale-105 hover:-translate-y-2' : 'animate-pulse'
//             } ${isAnimating ? 'scale-110 rotate-3' : ''}`}
//             onClick={handleExpand}
//           >
//             {/* Main Card */}
//             <div className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-6 max-w-xs border border-white/20">
              
//               {/* Header with Plane Icon */}
//               <div className="flex items-center justify-between mb-4">
//                 <div className="flex items-center gap-2">
//                   <div className="w-8 h-8 bg-gradient-to-br from-sky-500 to-blue-600 rounded-full flex items-center justify-center">
//                     <Plane size={16} className="text-white transform rotate-12" />
//                   </div>
//                   <div>
//                     <h3 className="text-lg font-bold text-gray-800">WANDERLUST</h3>
//                     <p className="text-xs text-gray-600">Travel Adventures</p>
//                   </div>
//                 </div>
//                 <Heart size={20} className="text-red-500 animate-pulse" />
//               </div>

//               {/* Destination Carousel */}
//               <div className="relative mb-4 overflow-hidden rounded-lg h-32">
//                 <div 
//                   className="flex transition-transform duration-500"
//                   style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//                 >
//                   {destinations.map((dest, index) => (
//                     <div key={index} className="w-full flex-shrink-0 relative">
//                       <div className="h-32 bg-gradient-to-br from-sky-300 to-blue-500 flex items-center justify-center text-4xl">
//                         {dest.image}
//                       </div>
//                       <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
//                         <h4 className="text-white font-semibold text-sm">{dest.name}</h4>
//                         <p className="text-white/80 text-xs">{dest.country}</p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
                
//                 {/* Carousel Indicators */}
//                 <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1">
//                   {destinations.map((_, index) => (
//                     <div
//                       key={index}
//                       className={`w-1.5 h-1.5 rounded-full transition-colors duration-300 ${
//                         index === currentSlide ? 'bg-white' : 'bg-white/50'
//                       }`}
//                     />
//                   ))}
//                 </div>
//               </div>

//               {/* Features */}
//               <div className="grid grid-cols-2 gap-2 mb-4">
//                 <div className="flex items-center gap-2">
//                   <MapPin size={14} className="text-sky-600" />
//                   <span className="text-xs text-gray-700">50+ Destinations</span>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <Calendar size={14} className="text-sky-600" />
//                   <span className="text-xs text-gray-700">Flexible Dates</span>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <Camera size={14} className="text-sky-600" />
//                   <span className="text-xs text-gray-700">Photo Tours</span>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <Star size={14} className="text-yellow-500" />
//                   <span className="text-xs text-gray-700">5-Star Rated</span>
//                 </div>
//               </div>

//               {/* CTA Button */}
//               <button className="w-full bg-gradient-to-r from-sky-500 to-blue-600 text-white font-bold py-3 px-4 rounded-lg hover:from-sky-600 hover:to-blue-700 transition-all duration-300 transform hover:scale-105 shadow-lg">
//                 <div className="flex items-center justify-center gap-2">
//                   <Globe size={16} />
//                   <span>Explore Now</span>
//                 </div>
//               </button>

//               {/* Price Tag */}
//               <div className="text-center mt-3">
//                 <span className="text-gray-600 text-sm">Starting from </span>
//                 <span className="text-sky-600 font-bold text-lg">{destinations[currentSlide].price}</span>
//               </div>
//             </div>

//             {/* Hover Indicator */}
//             {showInteraction && !isAnimating && (
//               <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 animate-bounce">
//                 <div className="bg-black/70 text-white px-3 py-1 rounded-full text-xs whitespace-nowrap">
//                   Click to explore!
//                 </div>
//               </div>
//             )}

//             {/* Floating Elements */}
//             <div className="absolute -inset-6 pointer-events-none">
//               {[...Array(6)].map((_, i) => (
//                 <div
//                   key={i}
//                   className="absolute w-2 h-2 bg-white rounded-full animate-pulse"
//                   style={{
//                     left: `${20 + Math.random() * 60}%`,
//                     top: `${20 + Math.random() * 60}%`,
//                     animationDelay: `${i * 0.5}s`,
//                     animationDuration: '3s'
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       ) : (
//         /* Expanded Travel Experience */
//         <div className=" w-full h-full  flex items-center justify-center relative overflow-hidden">
//           <button
//             onClick={closeAd}
//             className="absolute top-4 right-4 w-8 h-8 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-lg font-bold transition-all duration-300 hover:scale-110 z-10"
//           >
//             ×
//           </button>
          
//           <div className="relative p-2 text-center max-w-md  ">
//             {/* Header */}
//             <div className="flex items-center justify-center mb-2 ">
//               <div className="text-xl font-bold text-white mr-3">WANDERLUST</div>
//               <Plane size={30} className="text-sky-400 animate-pulse" />
//             </div>
            
//             {/* Main Content */}
//             <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-1 border border-white/20 ">
//               <h2 className="text-xl font-bold text-white mb-1">
//                 🌍 Adventure Awaits! 
//               </h2>
              
//               <div className="grid grid-cols-2 gap-2 mb-2">
//                 {destinations.map((dest, index) => (
//                   <div key={index} className="bg-white/20 rounded-lg p-1 hover:bg-white/30 transition-all duration-300 cursor-pointer">
//                     <div className="text-2xl mb-1">{dest.image}</div>
//                     <h4 className="text-white font-semibold text-sm">{dest.name}</h4>
//                     <p className="text-white/80 text-xs">{dest.country}</p>
//                     <p className="text-sky-300 font-bold text-sm">{dest.price}</p>
//                   </div>
//                 ))}
//               </div>

//               {/* Features Grid */}
//               <div className="grid grid-cols-2 gap-3 mb-2">
//                 <div className="flex items-center gap-2 text-white">
//                   <MapPin size={18} className="text-sky-400" />
//                   <span className="text-sm">50+ Destinations</span>
//                 </div>
//                 <div className="flex items-center gap-2 text-white">
//                   <Calendar size={18} className="text-sky-400" />
//                   <span className="text-sm">Flexible Booking</span>
//                 </div>
//                 <div className="flex items-center gap-2 text-white">
//                   <Camera size={18} className="text-sky-400" />
//                   <span className="text-sm">Photo Tours</span>
//                 </div>
//                 <div className="flex items-center gap-2 text-white">
//                   <Star size={18} className="text-yellow-400" />
//                   <span className="text-sm">5-Star Rated</span>
//                 </div>
//               </div>

//               {/* CTA */}
//               <button className="w-full bg-gradient-to-r from-sky-500 to-blue-600 text-white font-bold py-2 px-2 rounded-lg hover:from-sky-600 hover:to-blue-700 transition-all duration-300 transform hover:scale-105 shadow-xl mb-4">
//                 <div className="flex items-center justify-center gap-2">
//                   <Globe size={20} />
//                   <span>Book Your Adventure</span>
//                 </div>
//               </button>

//               <p className="text-white/80 text-sm">
//                 ✈️ Free cancellation • 24/7 support • Best price guarantee
//               </p>
//             </div>
//           </div>

//           {/* Background Animation */}
//           <div className="absolute inset-0 pointer-events-none">
//             {[...Array(20)].map((_, i) => (
//               <div
//                 key={i}
//                 className="absolute w-1 h-1 bg-white rounded-full animate-ping"
//                 style={{
//                   left: `${Math.random() * 100}%`,
//                   top: `${Math.random() * 100}%`,
//                   animationDelay: `${Math.random() * 3}s`,
//                   animationDuration: `${2 + Math.random() * 2}s`
//                 }}
//               />
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default function TravelAdMockup() {
//     const [selectedDevice, setSelectedDevice] = useState('Mobile');
//     const [isPlaying, setIsPlaying] = useState(false);

//     return (
//         <div className="mt-14 min-h-screen bg-gradient-to-br from-slate-50 via-sky-50 to-blue-50 p-6">
//             {/* Header */}
//             <div className="mb-8">
//                 <div className="flex items-center justify-between">
//                     <div>
//                         <h1 className="text-3xl font-bold text-gray-900 mb-2">Wanderlust Travel Campaign</h1>
//                         <p className="text-gray-600">Interactive travel ad with destination carousel</p>
//                     </div>
//                     <div className="flex items-center gap-3">
//                         <button className="px-4 py-2 bg-white rounded-lg shadow-sm border border-gray-200 hover:bg-gray-50 transition-colors flex items-center gap-2">
//                             <Settings className="h-4 w-4" />
//                             Settings
//                         </button>
//                         <button className="px-4 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition-colors flex items-center gap-2">
//                             <Share2 className="h-4 w-4" />
//                             Share
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
//                 {/* Left Sidebar - Project Info */}
//                 <div className="lg:col-span-1">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <div className="flex items-center gap-3 mb-4">
//                             <div className="w-12 h-12 bg-gradient-to-br from-sky-500 to-blue-600 rounded-xl flex items-center justify-center">
//                                 <Plane className="h-6 w-6 text-white" />
//                             </div>
//                             <div>
//                                 <h2 className="text-lg font-semibold text-gray-900">Wanderlust Travel</h2>
//                                 <p className="text-sm text-gray-500">ID: 654321</p>
//                             </div>
//                         </div>
                        
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Status</span>
//                                 <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">Active</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Campaign</span>
//                                 <span className="text-sm text-gray-900">Summer 2024</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Updated</span>
//                                 <span className="text-sm text-gray-900">2 hours ago</span>
//                             </div>
//                         </div>

//                         <button className="w-full mt-4 text-sky-600 hover:text-sky-700 text-sm font-medium">
//                             View Campaign Analytics
//                         </button>
//                     </div>

//                     {/* Quick Actions */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
//                         <div className="space-y-3">
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-sm transition-colors flex items-center gap-2">
//                                 <Download className="h-4 w-4" />
//                                 Export Creative
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-sm transition-colors flex items-center gap-2">
//                                 <Copy className="h-4 w-4" />
//                                 Copy Ad Tag
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-sm transition-colors flex items-center gap-2">
//                                 <Maximize2 className="h-4 w-4" />
//                                 Fullscreen Test
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Center Content - Preview Area */}
//                 <div className="lg:col-span-2">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
//                         {/* Device Toggle */}
//                         <div className="flex items-center justify-between mb-6">
//                             <div className="flex items-center gap-2">
//                                 <h3 className="text-lg font-semibold text-gray-900">Interactive Preview</h3>
//                                 <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600 transition-colors" />
//                             </div>
//                             <div className="flex items-center bg-gray-100 rounded-lg p-1">
//                                 {[
//                                     { name: 'Mobile', icon: Smartphone },
//                                     { name: 'Desktop', icon: Monitor }
//                                 ].map(({ name, icon: Icon }) => (
//                                     <button
//                                         key={name}
//                                         className={`px-3 py-2 rounded-md text-sm font-medium transition-all flex items-center gap-2 ${
//                                             selectedDevice === name
//                                                 ? 'bg-white text-sky-600 shadow-sm'
//                                                 : 'text-gray-600 hover:text-gray-900'
//                                         }`}
//                                         onClick={() => setSelectedDevice(name)}
//                                     >
//                                         <Icon className="h-4 w-4" />
//                                         {name}
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Navigation */}
//                         <div className="flex items-center justify-between mb-6">
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors">
//                                 <ChevronLeft className="h-4 w-4" />
//                                 Previous Ad
//                             </button>
//                             <div className="flex items-center gap-2">
//                                 <div className="w-2 h-2 bg-sky-600 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                             </div>
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors">
//                                 Next Ad
//                                 <ChevronRight className="h-4 w-4" />
//                             </button>
//                         </div>

//                         {/* Preview Container */}
//                         <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-8 min-h-[600px] flex items-center justify-center">
//                             {/* Device Frame */}
//                             <div className="relative">
//                                 {selectedDevice === 'Mobile' ? (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-sky-500/20 to-blue-500/20 rounded-3xl blur-xl"></div>
//                                         <div className="relative bg-gray-900 rounded-3xl p-2 shadow-2xl">
//                                             <div className="bg-black rounded-2xl overflow-hidden">
//                                                 <div className="w-[280px] h-[560px] relative">
//                                                     <TravelAdContent isInPreview={true} />
//                                                 </div>
//                                             </div>
//                                             <div className="w-20 h-1 bg-gray-600 rounded-full mx-auto mt-2"></div>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-sky-500/20 to-blue-500/20 rounded-xl blur-xl"></div>
//                                         <div className="relative bg-white rounded-xl shadow-2xl p-4">
//                                             <div className="bg-gray-100 rounded-lg p-2">
//                                                 <div className="w-[320px] h-[600px] bg-black rounded overflow-hidden relative">
//                                                     <TravelAdContent isInPreview={true} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Interaction Guide */}
//                         <div className="mt-6 bg-sky-50 rounded-lg p-4">
//                             <div className="flex items-center gap-3">
//                                 <div className="w-8 h-8 bg-sky-600 text-white rounded-full flex items-center justify-center">
//                                     <Plane className="h-4 w-4" />
//                                 </div>
//                                 <div>
//                                     <h4 className="font-semibold text-sky-900">Interactive Elements</h4>
//                                     <p className="text-sm text-sky-700">Click the travel card to explore destinations and view full ad experience</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Right Sidebar - Details */}
//                 <div className="lg:col-span-1">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Creative Details</h3>
                        
//                         <div className="space-y-4">
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">Dimensions</div>
//                                 <div className="text-lg font-semibold text-gray-900">320 × 600px</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">Format</div>
//                                 <div className="text-lg font-semibold text-gray-900">Interactive HTML5</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">Animation</div>
//                                 <div className="text-lg font-semibold text-gray-900">React + CSS</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">File Size</div>
//                                 <div className="text-lg font-semibold text-gray-900">2.1 MB</div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Performance Metrics */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Engagement Stats</h3>
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Interaction Rate</span>
//                                 <span className="text-sm font-semibold text-green-600">5.7%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Click Through</span>
//                                 <span className="text-sm font-semibold text-blue-600">4.9%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Completion Rate</span>
//                                 <span className="text-sm font-semibold text-purple-600">92%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Animation Timeline */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Animation Flow</h3>
//                         <div className="space-y-3">
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-sky-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Initial card animation (0-2s)</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Destination carousel (2s+)</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-green-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Interaction prompt (2s)</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Expanded experience</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// // }
// import React, { useState } from 'react';
// import { ArrowLeft, Eye, ArrowRight } from 'lucide-react';

// function TravelAdLayout() {
//   const [isMobile, setIsMobile] = useState(true);

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <div className="container mx-auto px-4 py-8 lg:py-12">
//         <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
//           {/* Left column - Content */}
//           <div className="flex-1 lg:max-w-lg">
//             {/* Header */}
//             <header className="animate-slide-up">
//               {/* Back to Ad Gallery */}
//               <div className="mb-6 lg:mb-8">
//                 <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
//                   <ArrowLeft className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform duration-200" />
//                   <span className="text-sm font-medium">Back to Ad Gallery</span>
//                 </button>
//               </div>

//               {/* Title and tag */}
//               <div className="mb-4">
//                 <div className="flex flex-wrap items-center gap-3 mb-3">
//                   <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
//                     You travel & cruise Blinds
//                   </h1>
//                   <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
//                     Blinds
//                   </span>
//                 </div>
                
//                 {/* View in preview site */}
//                 <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
//                   <Eye className="w-4 h-4" />
//                   <span className="text-sm font-medium group-hover:underline">View in preview site</span>
//                 </button>
//               </div>
//             </header>

//             {/* Content Section */}
//             <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
//               {/* Make it yours section */}
//               <div className="mb-8">
//                 <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
//                   MAKE IT YOURS!
//                 </h2>
//                 <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
//                   You can start with this premade template – just 
//                   change the assets to your own and you can 
//                   have your creative ready in no time.
//                 </p>
                
//                 {/* CTA Button */}
//                 <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
//                   <span>Start with this Template</span>
//                   <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Right column - Template Preview */}
//           <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
//             <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
//               {/* Mobile Mockup */}
//               {isMobile && (
//                 <div className="mx-auto max-w-sm">
//                   {/* iPhone mockup */}
//                   <div className="relative bg-black rounded-[2.5rem] p-2 shadow-2xl">
//                     {/* Status bar area */}
//                     <div className="bg-white rounded-[2rem] overflow-hidden">
//                       {/* Status bar */}
//                       <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
//                         <span>9:41</span>
//                         <div className="flex items-center space-x-1">
//                           <div className="flex space-x-1">
//                             <div className="w-4 h-2 bg-black rounded-sm"></div>
//                             <div className="w-4 h-2 bg-black rounded-sm"></div>
//                             <div className="w-4 h-2 bg-black rounded-sm"></div>
//                             <div className="w-4 h-2 bg-black rounded-sm"></div>
//                           </div>
//                           <div className="w-6 h-3 border border-black rounded-sm">
//                             <div className="w-full h-full bg-green-500 rounded-sm"></div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Browser bar */}
//                       <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
//                         <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
//                           publisher.com
//                           <button className="ml-2 text-gray-400">
//                             <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                               <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
//                             </svg>
//                           </button>
//                         </div>
//                       </div>

//                       {/* Content area */}
//                       <div className="p-4 bg-gray-50 min-h-[500px]">
//                         {/* Content placeholders */}
//                         <div className="space-y-3 mb-6">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-3/4"></div>
//                           <div className="h-3 bg-gray-200 rounded w-1/2"></div>
//                         </div>

//                         {/* Ad templates - Mobile layout (2x2 grid) */}
//                         <div className="grid grid-cols-2 gap-3 mb-6">
//                           {/* Viking Cruise Ad - Top Left */}
//                           <div className="relative group cursor-pointer transform transition-all duration-300 hover:scale-105">
//                             <div className="bg-gradient-to-br from-pink-500 to-red-600 rounded-lg p-3 text-white h-28 flex flex-col justify-between overflow-hidden relative">
//                               <div className="relative z-10">
//                                 <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center mb-2">
//                                   <span className="text-pink-600 font-bold text-xs">you</span>
//                                 </div>
//                                 <div className="text-xs font-medium leading-tight">
//                                   Discover the Heart of Expedition
//                                   <br />
//                                   <span className="text-pink-100">with Viking</span>
//                                   <br />
//                                   <span className="text-pink-100">Expedition Cruises</span>
//                                 </div>
//                               </div>
//                               <div className="absolute -bottom-2 -right-2 w-12 h-12 bg-white bg-opacity-20 rounded-full"></div>
//                               <div className="absolute bottom-1 right-1 text-xs bg-white bg-opacity-20 px-1 py-0.5 rounded text-pink-100">
//                                 #EXPEDITION
//                               </div>
//                             </div>
//                           </div>

//                           {/* Penguin Adventure Ad - Top Right */}
//                           <div className="relative group cursor-pointer transform transition-all duration-300 hover:scale-105">
//                             <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg overflow-hidden h-28 relative">
//                               <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent z-10"></div>
//                               <div className="relative z-20 p-3 h-full flex flex-col justify-between text-white">
//                                 <div className="flex justify-between items-start">
//                                   <div className="w-5 h-5 bg-blue-400 rounded-full flex items-center justify-center">
//                                     <div className="w-2 h-2 bg-white rounded-full"></div>
//                                   </div>
//                                   <div className="text-xs bg-orange-500 px-2 py-1 rounded font-bold">
//                                     1+
//                                   </div>
//                                 </div>
//                                 <div className="text-xs font-medium">
//                                   Antarctic Adventure
//                                 </div>
//                               </div>
//                               {/* Penguin silhouettes */}
//                               <div className="absolute right-2 bottom-2 w-6 h-6 bg-white bg-opacity-30 rounded-full"></div>
//                               <div className="absolute right-6 bottom-4 w-4 h-4 bg-white bg-opacity-20 rounded-full"></div>
//                             </div>
//                           </div>

//                           {/* Gray placeholder ad - Bottom Left */}
//                           <div className="bg-gradient-to-br from-gray-300 to-gray-400 rounded-lg h-28 relative overflow-hidden group cursor-pointer transform transition-all duration-300 hover:scale-105">
//                             <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
//                             <div className="relative z-10 p-3 h-full flex items-end">
//                               <div className="w-full h-2 bg-white bg-opacity-40 rounded"></div>
//                             </div>
//                           </div>

//                           {/* Orange destination ad - Bottom Right */}
//                           <div className="relative group cursor-pointer transform transition-all duration-300 hover:scale-105">
//                             <div className="bg-gradient-to-br from-orange-500 to-red-600 rounded-lg p-3 text-white h-28 flex flex-col justify-between overflow-hidden relative">
//                               <div className="absolute top-2 right-2 text-xs bg-white bg-opacity-20 px-1 py-0.5 rounded">
//                                 1-800-998-8873
//                               </div>
//                               <div className="absolute bottom-2 right-2 text-xs bg-purple-600 px-1 py-0.5 rounded">
//                                 @vikingcruise
//                               </div>
//                               <div className="mt-auto">
//                                 <div className="text-xs font-medium">Tropical Destinations</div>
//                               </div>
//                               <div className="absolute -top-4 -left-4 w-16 h-16 bg-yellow-400 bg-opacity-30 rounded-full"></div>
//                             </div>
//                           </div>
//                         </div>

//                         {/* Additional content placeholders */}
//                         <div className="space-y-3">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                         </div>
//                       </div>

//                       {/* Bottom navigation */}
//                       <div className="bg-gray-100 px-4 py-3 flex justify-center space-x-6 border-t border-gray-200">
//                         <button className="text-gray-400 hover:text-gray-600 transition-colors">
//                           <ArrowLeft className="w-5 h-5" />
//                         </button>
//                         <button className="text-gray-400 hover:text-gray-600 transition-colors">
//                           <ArrowRight className="w-5 h-5" />
//                         </button>
//                         <button className="text-gray-400 hover:text-gray-600 transition-colors">
//                           <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                             <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
//                             <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
//                           </svg>
//                         </button>
//                         <button className="text-gray-400 hover:text-gray-600 transition-colors">
//                           <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                             <path fillRule="evenodd" d="M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 11-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 010-2h4a1 1 0 011 1v4a1 1 0 01-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 012 0v1.586l2.293-2.293a1 1 0 111.414 1.414L6.414 15H8a1 1 0 010 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 010-2h1.586l-2.293-2.293a1 1 0 111.414-1.414L15 13.586V12a1 1 0 011-1z" clipRule="evenodd" />
//                           </svg>
//                         </button>
//                         <button className="text-gray-400 hover:text-gray-600 transition-colors">
//                           <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                             <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
//                           </svg>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Desktop Mockup */}
//               {!isMobile && (
//                 <div className="bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden">
//                   {/* Browser header */}
//                   <div className="bg-gray-100 px-4 py-3 flex items-center space-x-2 border-b border-gray-200">
//                     <div className="flex space-x-1.5">
//                       <div className="w-3 h-3 bg-red-400 rounded-full"></div>
//                       <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
//                       <div className="w-3 h-3 bg-green-400 rounded-full"></div>
//                     </div>
//                     <div className="flex-1 mx-4">
//                       <div className="bg-white rounded-md px-3 py-1 text-xs text-gray-600 border">
//                         publisher.com
//                       </div>
//                     </div>
//                     <div className="w-4 h-4 border border-gray-300 rounded-sm"></div>
//                   </div>

//                   {/* Content area */}
//                   <div className="p-6 space-y-6 bg-gray-50 min-h-[500px]">
//                     {/* Header content placeholder */}
//                     <div className="space-y-3">
//                       <div className="h-4 bg-gray-200 rounded w-3/4"></div>
//                       <div className="h-4 bg-gray-200 rounded w-1/2"></div>
//                     </div>

//                     {/* Ad templates grid - Desktop layout (4 in a row) */}
//                     <div className="grid grid-cols-4 gap-4">
//                       {/* Viking Cruise Ad */}
//                       <div className="relative group cursor-pointer transform transition-all duration-300 hover:scale-105 hover:z-10">
//                         <div className="bg-gradient-to-br from-pink-500 to-red-600 rounded-lg p-4 text-white h-32 flex flex-col justify-between overflow-hidden relative">
//                           <div className="relative z-10">
//                             <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center mb-2">
//                               <span className="text-pink-600 font-bold text-sm">you</span>
//                             </div>
//                             <div className="text-xs font-medium leading-tight">
//                               Discover the Heart of Expedition
//                               <br />
//                               <span className="text-pink-100">with Viking</span>
//                               <br />
//                               <span className="text-pink-100">Expedition Cruises</span>
//                             </div>
//                           </div>
//                           <div className="absolute -bottom-2 -right-2 w-16 h-16 bg-white bg-opacity-20 rounded-full"></div>
//                           <div className="absolute bottom-2 right-2 text-xs bg-white bg-opacity-20 px-2 py-1 rounded text-pink-100">
//                             #EXPEDITION
//                           </div>
//                         </div>
//                       </div>

//                       {/* Penguin Adventure Ad */}
//                       <div className="relative group cursor-pointer transform transition-all duration-300 hover:scale-105 hover:z-10">
//                         <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg overflow-hidden h-32 relative">
//                           <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent z-10"></div>
//                           <div className="relative z-20 p-4 h-full flex flex-col justify-between text-white">
//                             <div className="flex justify-between items-start">
//                               <div className="w-6 h-6 bg-blue-400 rounded-full flex items-center justify-center">
//                                 <div className="w-3 h-3 bg-white rounded-full"></div>
//                               </div>
//                               <div className="text-xs bg-orange-500 px-2 py-1 rounded font-bold">
//                                 1+
//                               </div>
//                             </div>
//                             <div className="text-xs font-medium">
//                               Antarctic Adventure
//                             </div>
//                           </div>
//                           {/* Penguin silhouettes */}
//                           <div className="absolute right-2 bottom-2 w-8 h-8 bg-white bg-opacity-30 rounded-full"></div>
//                           <div className="absolute right-6 bottom-4 w-6 h-6 bg-white bg-opacity-20 rounded-full"></div>
//                         </div>
//                       </div>

//                       {/* Gray placeholder ad */}
//                       <div className="bg-gradient-to-br from-gray-300 to-gray-400 rounded-lg h-32 relative overflow-hidden group cursor-pointer transform transition-all duration-300 hover:scale-105">
//                         <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
//                         <div className="relative z-10 p-4 h-full flex items-end">
//                           <div className="w-full h-2 bg-white bg-opacity-40 rounded"></div>
//                         </div>
//                       </div>

//                       {/* Orange destination ad */}
//                       <div className="relative group cursor-pointer transform transition-all duration-300 hover:scale-105 hover:z-10">
//                         <div className="bg-gradient-to-br from-orange-500 to-red-600 rounded-lg p-4 text-white h-32 flex flex-col justify-between overflow-hidden relative">
//                           <div className="absolute top-2 right-2 text-xs bg-white bg-opacity-20 px-2 py-1 rounded">
//                             1-800-998-8873
//                           </div>
//                           <div className="absolute bottom-2 right-2 text-xs bg-purple-600 px-2 py-1 rounded">
//                             @vikingcruise
//                           </div>
//                           <div className="mt-auto">
//                             <div className="text-xs font-medium">Tropical Destinations</div>
//                           </div>
//                           <div className="absolute -top-4 -left-4 w-20 h-20 bg-yellow-400 bg-opacity-30 rounded-full"></div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Additional content placeholders */}
//                     <div className="space-y-3">
//                       <div className="h-3 bg-gray-200 rounded w-full"></div>
//                       <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                       <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                     </div>

//                     <div className="grid grid-cols-2 gap-4">
//                       <div className="h-20 bg-gray-200 rounded"></div>
//                       <div className="h-20 bg-gray-200 rounded"></div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Preview toggle */}
//               <div className="flex justify-center mt-6 animate-fade-in" style={{ animationDelay: '0.3s' }}>
//                 <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
//                   <div className="flex items-center space-x-4">
//                     <span className="text-sm text-gray-600 font-medium">Preview in:</span>
//                     <div className="flex items-center space-x-3">
//                       <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                         Mobile
//                       </span>
//                       <button
//                         onClick={() => setIsMobile(!isMobile)}
//                         className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
//                       >
//                         <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
//                       </button>
//                       <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                         Desktop
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default TravelAdLayout;

// import React, { useState, useEffect } from 'react';
// import { ArrowLeft, Eye, ArrowRight, Plane, Heart, MapPin, Calendar, Camera, Star, Globe } from 'lucide-react';

// const TravelAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
//   const [showInteraction, setShowInteraction] = useState(false);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);

//   const destinations = [
//     { name: "Santorini", country: "Greece", image: "🏝️", price: "$1,299" },
//     { name: "Tokyo", country: "Japan", image: "🗾", price: "$1,599" },
//     { name: "Bali", country: "Indonesia", image: "🌺", price: "$899" },
//     { name: "Swiss Alps", country: "Switzerland", image: "🏔️", price: "$1,899" }
//   ];

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowInteraction(true);
//     }, 2000);
//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     if (!isExpanded) {
//       const slideTimer = setInterval(() => {
//         setCurrentSlide((prev) => (prev + 1) % destinations.length);
//       }, 3000);
//       return () => clearInterval(slideTimer);
//     }
//   }, [isExpanded, destinations.length]);

//   const handleExpand = () => {
//     if (onExpand) {
//       setIsAnimating(true);
//       setTimeout(() => {
//         onExpand();
//         setIsAnimating(false);
//       }, 300);
//     }
//   };

//   return (
//     <div className={`w-full h-full bg-gradient-to-br from-sky-400 via-blue-500 to-indigo-600 relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50' : ''}`}>
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0">
//         {/* Floating Clouds */}
//         {[...Array(isInPreview ? 3 : 6)].map((_, i) => (
//           <div
//             key={i}
//             className="absolute bg-white bg-opacity-20 rounded-full animate-float"
//             style={{
//               width: `${60 + Math.random() * 80}px`,
//               height: `${30 + Math.random() * 40}px`,
//               left: `${Math.random() * 100}%`,
//               top: `${Math.random() * 100}%`,
//               animationDelay: `${Math.random() * 3}s`,
//               animationDuration: `${3 + Math.random() * 2}s`,
//               transform: `translateX(${Math.sin(i) * 20}px)`
//             }}
//           />
//         ))}
        
//         {/* Twinkling Stars */}
//         {[...Array(isInPreview ? 8 : 15)].map((_, i) => (
//           <div
//             key={i}
//             className="absolute w-1 h-1 bg-white rounded-full animate-ping"
//             style={{
//               left: `${Math.random() * 100}%`,
//               top: `${Math.random() * 100}%`,
//               animationDelay: `${Math.random() * 2}s`,
//               animationDuration: `${1 + Math.random() * 2}s`
//             }}
//           />
//         ))}
//       </div>

//       {!isExpanded ? (
//         <div className="relative h-full flex items-center justify-center p-2">
//           {/* Compact Travel Ad */}
//           <div 
//             className={`relative cursor-pointer transform transition-all duration-700 ${
//               showInteraction ? 'hover:scale-105 hover:-translate-y-2' : 'animate-pulse'
//             } ${isAnimating ? 'scale-110 rotate-3' : ''} w-full max-w-xs`}
//             onClick={handleExpand}
//           >
//             {/* Main Card */}
//             <div className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-4 lg:p-6 border border-white/20 w-full">
              
//               {/* Header with Plane Icon */}
//               <div className="flex items-center justify-between mb-3 lg:mb-4">
//                 <div className="flex items-center gap-2">
//                   <div className="w-6 h-6 lg:w-8 lg:h-8 bg-gradient-to-br from-sky-500 to-blue-600 rounded-full flex items-center justify-center">
//                     <Plane size={isInPreview ? 12 : 16} className="text-white transform rotate-12" />
//                   </div>
//                   <div>
//                     <h3 className="text-sm lg:text-lg font-bold text-gray-800">WANDERLUST</h3>
//                     <p className="text-xs text-gray-600">Travel Adventures</p>
//                   </div>
//                 </div>
//                 <Heart size={16} className="text-red-500 animate-pulse" />
//               </div>

//               {/* Destination Carousel */}
//               <div className="relative mb-3 lg:mb-4 overflow-hidden rounded-lg h-24 lg:h-32">
//                 <div 
//                   className="flex transition-transform duration-500"
//                   style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//                 >
//                   {destinations.map((dest, index) => (
//                     <div key={index} className="w-full flex-shrink-0 relative">
//                       <div className="h-24 lg:h-32 bg-gradient-to-br from-sky-300 to-blue-500 flex items-center justify-center text-2xl lg:text-4xl">
//                         {dest.image}
//                       </div>
//                       <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-2 lg:p-3">
//                         <h4 className="text-white font-semibold text-xs lg:text-sm">{dest.name}</h4>
//                         <p className="text-white/80 text-xs">{dest.country}</p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
                
//                 {/* Carousel Indicators */}
//                 <div className="absolute bottom-1 lg:bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1">
//                   {destinations.map((_, index) => (
//                     <div
//                       key={index}
//                       className={`w-1.5 h-1.5 rounded-full transition-colors duration-300 ${
//                         index === currentSlide ? 'bg-white' : 'bg-white/50'
//                       }`}
//                     />
//                   ))}
//                 </div>
//               </div>

//               {/* Features */}
//               <div className="grid grid-cols-2 gap-1 lg:gap-2 mb-3 lg:mb-4">
//                 <div className="flex items-center gap-1 lg:gap-2">
//                   <MapPin size={12} className="text-sky-600" />
//                   <span className="text-xs text-gray-700">50+ Destinations</span>
//                 </div>
//                 <div className="flex items-center gap-1 lg:gap-2">
//                   <Calendar size={12} className="text-sky-600" />
//                   <span className="text-xs text-gray-700">Flexible Dates</span>
//                 </div>
//                 <div className="flex items-center gap-1 lg:gap-2">
//                   <Camera size={12} className="text-sky-600" />
//                   <span className="text-xs text-gray-700">Photo Tours</span>
//                 </div>
//                 <div className="flex items-center gap-1 lg:gap-2">
//                   <Star size={12} className="text-yellow-500" />
//                   <span className="text-xs text-gray-700">5-Star Rated</span>
//                 </div>
//               </div>

//               {/* CTA Button */}
//               <button className="w-full bg-gradient-to-r from-sky-500 to-blue-600 text-white font-bold py-2 lg:py-3 px-3 lg:px-4 rounded-lg hover:from-sky-600 hover:to-blue-700 transition-all duration-300 transform hover:scale-105 shadow-lg">
//                 <div className="flex items-center justify-center gap-2">
//                   <Globe size={14} />
//                   <span className="text-xs lg:text-base">Explore Now</span>
//                 </div>
//               </button>

//               {/* Price Tag */}
//               <div className="text-center mt-2 lg:mt-3">
//                 <span className="text-gray-600 text-xs lg:text-sm">Starting from </span>
//                 <span className="text-sky-600 font-bold text-sm lg:text-lg">{destinations[currentSlide].price}</span>
//               </div>
//             </div>

//             {/* Hover Indicator */}
//             {showInteraction && !isAnimating && !isInPreview && (
//               <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 animate-bounce">
//                 <div className="bg-black/70 text-white px-3 py-1 rounded-full text-xs whitespace-nowrap">
//                   Click to explore!
//                 </div>
//               </div>
//             )}

//             {/* Floating Elements */}
//             {!isInPreview && (
//               <div className="absolute -inset-6 pointer-events-none">
//                 {[...Array(6)].map((_, i) => (
//                   <div
//                     key={i}
//                     className="absolute w-2 h-2 bg-white rounded-full animate-pulse"
//                     style={{
//                       left: `${20 + Math.random() * 60}%`,
//                       top: `${20 + Math.random() * 60}%`,
//                       animationDelay: `${i * 0.5}s`,
//                       animationDuration: '3s'
//                     }}
//                   />
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       ) : (
//         /* Expanded Travel Experience - Full Screen */
//         <div className="w-full h-full flex items-center justify-center relative overflow-hidden p-4">
//           <button
//             onClick={onClose}
//             className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
//           >
//             ×
//           </button>
          
//           <div className="relative text-center max-w-4xl w-full">
//             {/* Header */}
//             <div className="flex items-center justify-center mb-6 lg:mb-8">
//               <div className="text-2xl lg:text-4xl font-bold text-white mr-4">WANDERLUST</div>
//               <Plane size={40} className="text-sky-400 animate-pulse" />
//             </div>
            
//             {/* Main Content */}
//             <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-6 lg:p-8 border border-white/20">
//               <h2 className="text-2xl lg:text-4xl font-bold text-white mb-6 lg:mb-8">
//                 🌍 Adventure Awaits! 
//               </h2>
              
//               <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-6 lg:mb-8">
//                 {destinations.map((dest, index) => (
//                   <div key={index} className="bg-white/20 rounded-xl p-4 lg:p-6 hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-105">
//                     <div className="text-3xl lg:text-5xl mb-3">{dest.image}</div>
//                     <h4 className="text-white font-semibold text-sm lg:text-lg">{dest.name}</h4>
//                     <p className="text-white/80 text-xs lg:text-sm">{dest.country}</p>
//                     <p className="text-sky-300 font-bold text-sm lg:text-xl">{dest.price}</p>
//                   </div>
//                 ))}
//               </div>

//               {/* Features Grid */}
//               <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-6 lg:mb-8">
//                 <div className="flex items-center gap-3 text-white">
//                   <MapPin size={24} className="text-sky-400" />
//                   <span className="text-sm lg:text-lg">50+ Destinations</span>
//                 </div>
//                 <div className="flex items-center gap-3 text-white">
//                   <Calendar size={24} className="text-sky-400" />
//                   <span className="text-sm lg:text-lg">Flexible Booking</span>
//                 </div>
//                 <div className="flex items-center gap-3 text-white">
//                   <Camera size={24} className="text-sky-400" />
//                   <span className="text-sm lg:text-lg">Photo Tours</span>
//                 </div>
//                 <div className="flex items-center gap-3 text-white">
//                   <Star size={24} className="text-yellow-400" />
//                   <span className="text-sm lg:text-lg">5-Star Rated</span>
//                 </div>
//               </div>

//               {/* CTA */}
//               <button className="w-full max-w-md mx-auto bg-gradient-to-r from-sky-500 to-blue-600 text-white font-bold py-4 px-8 rounded-xl hover:from-sky-600 hover:to-blue-700 transition-all duration-300 transform hover:scale-105 shadow-xl mb-6">
//                 <div className="flex items-center justify-center gap-3">
//                   <Globe size={24} />
//                   <span className="text-lg lg:text-xl">Book Your Adventure</span>
//                 </div>
//               </button>

//               <p className="text-white/80 text-sm lg:text-lg">
//                 ✈️ Free cancellation • 24/7 support • Best price guarantee
//               </p>
//             </div>
//           </div>

//           {/* Background Animation */}
//           <div className="absolute inset-0 pointer-events-none">
//             {[...Array(30)].map((_, i) => (
//               <div
//                 key={i}
//                 className="absolute w-1 h-1 bg-white rounded-full animate-ping"
//                 style={{
//                   left: `${Math.random() * 100}%`,
//                   top: `${Math.random() * 100}%`,
//                   animationDelay: `${Math.random() * 3}s`,
//                   animationDuration: `${2 + Math.random() * 2}s`
//                 }}
//               />
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// function App() {
//   const [isMobile, setIsMobile] = useState(true);



//   return (
//     <div className="min-h-screen bg-gray-50 mt-10">
    

//       <div className="container mx-auto px-4 py-8 lg:py-12">
//         <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
//           {/* Left column - Content */}
//           <div className="flex-1 lg:max-w-lg">
//             {/* Header */}
//             <header className="animate-slide-up">
//               {/* Back to Ad Gallery */}
//               <div className="mb-6 lg:mb-8">
//                 <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
//                   <ArrowLeft className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform duration-200" />
//                   <span className="text-sm font-medium">Back to Ad Gallery</span>
//                 </button>
//               </div>

//               {/* Title and tag */}
//               <div className="mb-4">
//                 <div className="flex flex-wrap items-center gap-3 mb-3">
//                   <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
//                     You travel & cruise Blinds
//                   </h1>
//                   <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
//                     Blinds
//                   </span>
//                 </div>
                
//                 {/* View in preview site */}
//                 <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
//                   <Eye className="w-4 h-4" />
//                   <span className="text-sm font-medium group-hover:underline">View in preview site</span>
//                 </button>
//               </div>
//             </header>

//             {/* Content Section */}
//             <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
//               {/* Make it yours section */}
//               <div className="mb-8">
//                 <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
//                   MAKE IT YOURS!
//                 </h2>
//                 <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
//                   You can start with this premade template – just 
//                   change the assets to your own and you can 
//                   have your creative ready in no time.
//                 </p>
                
//                 {/* CTA Button */}
//                 <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
//                   <span>Start with this Template</span>
//                   <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Right column - Template Preview */}
//           <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
//             <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
//               {/* Mobile Mockup */}
//               {isMobile && (
//                 <div className="mx-auto max-w-sm">
//                   {/* iPhone mockup */}
//                   <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
//                     {/* Status bar area */}
//                     <div className="bg-white rounded-[2rem] overflow-hidden">
//                       {/* Status bar */}
//                       <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
//                         <span>9:41</span>
//                         <div className="flex items-center space-x-1">
//                           <div className="flex space-x-1">
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                             <div className="w-1 h-1 bg-black rounded-full"></div>
//                           </div>
//                           <div className="w-6 h-3 border border-black rounded-sm relative">
//                             <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Browser bar */}
//                       <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
//                         <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
//                           publisher.com
//                         </div>
//                       </div>

//                       {/* Content area */}
//                       <div className="p-4 bg-gray-50 min-h-[500px]">
                       

//                         {/* Travel Ad - Full width on mobile */}
//                         <div className="mb-6">
//                           <div className="relative group cursor-pointer transform transition-all duration-300 hover:scale-105  rounded-lg overflow-hidden">
//                             <TravelAdContent 
//                               isInPreview={true} 
                           
//                             />
//                           </div>
//                         </div>

//                         {/* Additional content placeholders */}
//                         <div className="space-y-3">
//                           <div className="h-3 bg-gray-200 rounded w-full"></div>
//                           <div className="h-3 bg-gray-200 rounded w-5/6"></div>
//                           <div className="h-3 bg-gray-200 rounded w-4/6"></div>
//                         </div>
//                       </div>

//                       {/* Bottom navigation */}
//                       <div className="bg-gray-100 px-4 py-3 flex justify-center space-x-6 border-t border-gray-200">
//                         <button className="text-gray-400 hover:text-gray-600 transition-colors">
//                           <ArrowLeft className="w-5 h-5" />
//                         </button>
//                         <button className="text-gray-400 hover:text-gray-600 transition-colors">
//                           <ArrowRight className="w-5 h-5" />
//                         </button>
//                         <button className="text-gray-400 hover:text-gray-600 transition-colors">
//                           <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                             <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
//                             <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
//                           </svg>
//                         </button>
//                         <button className="text-gray-400 hover:text-gray-600 transition-colors">
//                           <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                             <path fillRule="evenodd" d="M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 11-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 010-2h4a1 1 0 011 1v4a1 1 0 01-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 012 0v1.586l2.293-2.293a1 1 0 111.414 1.414L6.414 15H8a1 1 0 010 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 010-2h1.586l-2.293-2.293a1 1 0 111.414-1.414L15 13.586V12a1 1 0 011-1z" clipRule="evenodd" />
//                           </svg>
//                         </button>
//                         <button className="text-gray-400 hover:text-gray-600 transition-colors">
//                           <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
//                             <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
//                           </svg>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Desktop Mockup */}
//               {!isMobile && (
//                 <div className="bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden">
//                   {/* Browser header */}
//                   <div className="bg-gray-100 px-4 py-3 flex items-center space-x-2 border-b border-gray-200">
//                     <div className="flex space-x-1.5">
//                       <div className="w-3 h-3 bg-red-400 rounded-full"></div>
//                       <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
//                       <div className="w-3 h-3 bg-green-400 rounded-full"></div>
//                     </div>
//                     <div className="flex-1 mx-4">
//                       <div className="bg-white rounded-md px-3 py-1 text-xs text-gray-600 border">
//                         publisher.com
//                       </div>
//                     </div>
//                     <div className="w-4 h-4 border border-gray-300 rounded-sm"></div>
//                   </div>

//                   {/* Content area */}
//                   <div className="p-6 space-y-2 bg-gray-50 min-h-[400px]">
                

//                     {/* Travel Ad - Larger size on desktop */}
//                     <div className="flex justify-center">
//                       <div className="relative group cursor-pointer transform transition-all duration-300 hover:scale-105 hover:z-10  rounded-lg overflow-hidden shadow-lg">
//                         <TravelAdContent 
//                           isInPreview={true} 
//                           // onExpand={handleAdExpand}
//                         />
//                       </div>
//                     </div>

              

//                     <div className="grid grid-cols-2 gap-4">
//                       <div className="h-20 bg-gray-200 rounded"></div>
//                       <div className="h-20 bg-gray-200 rounded"></div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* Preview toggle */}
//               <div className="flex justify-center mt-6 animate-fade-in" style={{ animationDelay: '0.3s' }}>
//                 <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
//                   <div className="flex items-center space-x-4">
//                     <span className="text-sm text-gray-600 font-medium">Preview in:</span>
//                     <div className="flex items-center space-x-3">
//                       <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                         Mobile
//                       </span>
//                       <button
//                         onClick={() => setIsMobile(!isMobile)}
//                         className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
//                       >
//                         <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
//                       </button>
//                       <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
//                         Desktop
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
// </div>
//   );
// }

// export default App;

import React, { useState, useEffect } from 'react';
import { ArrowLeft, Eye, ArrowRight, Plane, Heart, MapPin, Calendar, Camera, Star, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const TravelAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
  const [showInteraction, setShowInteraction] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const destinations = [
    { name: "Santorini", country: "Greece", image: "/assets/travelad.jpg", price: "$1,299" },
    { name: "Tokyo", country: "Japan", image: "/assets/tokyo.webp", price: "$1,599" },
    { name: "Bali", country: "Indonesia", image: "/assets/bali.jpeg", price: "$899" },
    { name: "Swiss Alps", country: "Switzerland", image: "/assets/swiss.jpg", price: "$1,899" }
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowInteraction(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isExpanded) {
      const slideTimer = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % destinations.length);
      }, 3000);
      return () => clearInterval(slideTimer);
    }
  }, [isExpanded, destinations.length]);

  const handleExpand = () => {
    if (onExpand) {
      setIsAnimating(true);
      setTimeout(() => {
        onExpand();
        setIsAnimating(false);
      }, 300);
    }
  };

  return (
    // <div className={`w-full h-full bg-gradient-to-br from-sky-400 via-blue-500 to-indigo-600 relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50' : ''}`}>
    //   {/* Animated Background Elements */}
    //   <div className="absolute inset-0">
    //     {/* Floating Clouds */}
    //     {[...Array(isInPreview ? 3 : 6)].map((_, i) => (
    //       <div
    //         key={i}
    //         className="absolute bg-white bg-opacity-20 rounded-full animate-float"
    //         style={{
    //           width: `${60 + Math.random() * 80}px`,
    //           height: `${30 + Math.random() * 40}px`,
    //           left: `${Math.random() * 100}%`,
    //           top: `${Math.random() * 100}%`,
    //           animationDelay: `${Math.random() * 3}s`,
    //           animationDuration: `${3 + Math.random() * 2}s`,
    //           transform: `translateX(${Math.sin(i) * 20}px)`
    //         }}
    //       />
    //     ))}
        
    //     {/* Twinkling Stars */}
    //     {[...Array(isInPreview ? 8 : 15)].map((_, i) => (
    //       <div
    //         key={i}
    //         className="absolute w-1 h-1 bg-white rounded-full animate-ping"
    //         style={{
    //           left: `${Math.random() * 100}%`,
    //           top: `${Math.random() * 100}%`,
    //           animationDelay: `${Math.random() * 2}s`,
    //           animationDuration: `${1 + Math.random() * 2}s`
    //         }}
    //       />
    //     ))}
    //   </div>

    //   {!isExpanded ? (
    //     <div className="relative h-full flex items-center justify-center p-2">
    //       {/* Compact Travel Ad */}
    //       {/* <div 
    //         className={`relative cursor-pointer transform transition-all duration-700 ${
    //           showInteraction ? 'hover:scale-105 hover:-translate-y-2' : 'animate-pulse'
    //         } ${isAnimating ? 'scale-110 rotate-3' : ''} w-full max-w-xs`}
    //         onClick={handleExpand}
    //       > */}
    //       <div className=''>
    //         {/* Main Card */}
    //         <div className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-2 lg:p-2 border border-white/20 w-full">
              
    //           {/* Header with Plane Icon */}
    //           <div className="flex items-center justify-between mb-2 lg:mb-2">
    //             <div className="flex items-center gap-2">
    //               <div className="w-6 h-6 lg:w-8 lg:h-8 bg-gradient-to-br from-sky-500 to-blue-600 rounded-full flex items-center justify-center">
    //                 <Plane size={isInPreview ? 12 : 16} className="text-white transform rotate-12" />
    //               </div>
    //               <div>
    //                 <h3 className="text-sm lg:text-md font-bold text-gray-800">WANDERLUST</h3>
    //                 <p className="text-xs text-gray-600">Travel Adventures</p>
    //               </div>
    //             </div>
    //             <Heart size={16} className="text-red-500 animate-pulse" />
    //           </div>

    //           {/* Destination Carousel */}
    //           <div className="relative mb-3 lg:mb-4 overflow-hidden rounded-lg h-24 lg:h-32">
    //             <div 
    //               className="flex transition-transform duration-500"
    //               style={{ transform: `translateX(-${currentSlide * 100}%)` }}
    //             >
    //               {destinations.map((dest, index) => (
    //                 <div key={index} className="w-full flex-shrink-0 relative">
    //                   {/* <div className="h-18 lg:h-24 bg-gradient-to-br from-sky-300 to-blue-500 flex items-center justify-center text-2xl lg:text-4xl">
    //                     {dest.image}
    //                   </div> */}
    //                    {/* Replace icon with image */}
    // <div className="h-18 lg:h-24 bg-gradient-to-br from-sky-300 to-blue-500 flex items-center justify-center text-2xl lg:text-4xl">
    //   <img
    //     src={dest.image}
    //     alt={dest.name}
    //     className="h-full w-full object-cover"
    //   />
    // </div>
    //                   <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-2 lg:p-2">
    //                     <h4 className="text-white font-semibold text-xs lg:text-sm">{dest.name}</h4>
    //                     <p className="text-white/80 text-xs">{dest.country}</p>
    //                   </div>
    //                 </div>
    //               ))}
    //             </div>
                
    //             {/* Carousel Indicators */}
    //             <div className="absolute bottom-1 lg:bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1">
    //               {destinations.map((_, index) => (
    //                 <div
    //                   key={index}
    //                   className={`w-1.5 h-1.5 rounded-full transition-colors duration-300 ${
    //                     index === currentSlide ? 'bg-white' : 'bg-white/50'
    //                   }`}
    //                 />
    //               ))}
    //             </div>
    //           </div>

    //           {/* Features */}
    //           <div className="grid grid-cols-2 gap-1 lg:gap-2 mb-3 lg:mb-1">
    //             <div className="flex items-center gap-1 lg:gap-1">
    //               <MapPin size={12} className="text-sky-600" />
    //               <span className="text-xs text-gray-700">50+ Destinations</span>
    //             </div>
    //             <div className="flex items-center gap-1 lg:gap-1">
    //               <Calendar size={12} className="text-sky-600" />
    //               <span className="text-xs text-gray-700">Flexible Dates</span>
    //             </div>
    //             <div className="flex items-center gap-1 lg:gap-1">
    //               <Camera size={12} className="text-sky-600" />
    //               <span className="text-xs text-gray-700">Photo Tours</span>
    //             </div>
    //             <div className="flex items-center gap-1 lg:gap-1">
    //               <Star size={12} className="text-yellow-500" />
    //               <span className="text-xs text-gray-700">5-Star Rated</span>
    //             </div>
    //           </div>

    //           {/* CTA Button */}
    //           <button className="w-full bg-gradient-to-r from-sky-500 to-blue-600 text-white font-bold py-1 lg:py-2 px-2 lg:px-2 rounded-lg hover:from-sky-600 hover:to-blue-700 transition-all duration-300 transform hover:scale-105 shadow-lg">
    //             <div className="flex items-center justify-center gap-2">
    //               <Globe size={14} />
    //               <span className="text-xs lg:text-base">Explore Now</span>
    //             </div>
    //           </button>

    //           {/* Price Tag */}
    //           <div className="text-center mt-1 lg:mt-1">
    //             <span className="text-gray-600 text-xs lg:text-sm">Starting from </span>
    //             <span className="text-sky-600 font-bold text-sm lg:text-md">{destinations[currentSlide].price}</span>
    //           </div>
    //         </div>

    //         {/* Hover Indicator */}
    //         {showInteraction && !isAnimating && !isInPreview && (
    //           <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 animate-bounce">
    //             <div className="bg-black/70 text-white px-3 py-1 rounded-full text-xs whitespace-nowrap">
    //               Click to explore!
    //             </div>
    //           </div>
    //         )}

    //         {/* Floating Elements */}
    //         {!isInPreview && (
    //           <div className="absolute -inset-6 pointer-events-none">
    //             {[...Array(6)].map((_, i) => (
    //               <div
    //                 key={i}
    //                 className="absolute w-2 h-2 bg-white rounded-full animate-pulse"
    //                 style={{
    //                   left: `${20 + Math.random() * 60}%`,
    //                   top: `${20 + Math.random() * 60}%`,
    //                   animationDelay: `${i * 0.5}s`,
    //                   animationDuration: '3s'
    //                 }}
    //               />
    //             ))}
    //           </div>
    //         )}
    //       </div>
    //     </div>
    //   ) : (
    //     /* Expanded Travel Experience - Full Screen */
    //     <div className="w-full h-full flex items-center justify-center relative overflow-hidden p-4">
    //       <button
    //         onClick={onClose}
    //         className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
    //       >
    //         ×
    //       </button>
          
    //       <div className="relative text-center max-w-4xl w-full">
    //         {/* Header */}
    //         <div className="flex items-center justify-center mb-6 lg:mb-8">
    //           <div className="text-2xl lg:text-4xl font-bold text-white mr-4">WANDERLUST</div>
    //           <Plane size={40} className="text-sky-400 animate-pulse" />
    //         </div>
            
    //         {/* Main Content */}
    //         <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-6 lg:p-8 border border-white/20">
    //           <h2 className="text-2xl lg:text-4xl font-bold text-white mb-6 lg:mb-8">
    //             🌍 Adventure Awaits! 
    //           </h2>
              
    //           <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-6 lg:mb-8">
    //             {destinations.map((dest, index) => (
    //               <div key={index} className="bg-white/20 rounded-xl p-4 lg:p-6 hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-105">
    //                 <div className="text-3xl lg:text-5xl mb-3">{dest.image}</div>
    //                 <h4 className="text-white font-semibold text-sm lg:text-lg">{dest.name}</h4>
    //                 <p className="text-white/80 text-xs lg:text-sm">{dest.country}</p>
    //                 <p className="text-sky-300 font-bold text-sm lg:text-xl">{dest.price}</p>
    //               </div>
    //             ))}
    //           </div>

    //           {/* Features Grid */}
    //           <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-6 lg:mb-8">
    //             <div className="flex items-center gap-3 text-white">
    //               <MapPin size={24} className="text-sky-400" />
    //               <span className="text-sm lg:text-lg">50+ Destinations</span>
    //             </div>
    //             <div className="flex items-center gap-3 text-white">
    //               <Calendar size={24} className="text-sky-400" />
    //               <span className="text-sm lg:text-lg">Flexible Booking</span>
    //             </div>
    //             <div className="flex items-center gap-3 text-white">
    //               <Camera size={24} className="text-sky-400" />
    //               <span className="text-sm lg:text-lg">Photo Tours</span>
    //             </div>
    //             <div className="flex items-center gap-3 text-white">
    //               <Star size={24} className="text-yellow-400" />
    //               <span className="text-sm lg:text-lg">5-Star Rated</span>
    //             </div>
    //           </div>

    //           {/* CTA */}
    //           <button className="w-full max-w-md mx-auto bg-gradient-to-r from-sky-500 to-blue-600 text-white font-bold py-4 px-8 rounded-xl hover:from-sky-600 hover:to-blue-700 transition-all duration-300 transform hover:scale-105 shadow-xl mb-6">
    //             <div className="flex items-center justify-center gap-3">
    //               <Globe size={24} />
    //               <span className="text-lg lg:text-xl">Book Your Adventure</span>
    //             </div>
    //           </button>

    //           <p className="text-white/80 text-sm lg:text-lg">
    //             ✈️ Free cancellation • 24/7 support • Best price guarantee
    //           </p>
    //         </div>
    //       </div>

    //       {/* Background Animation */}
    //       <div className="absolute inset-0 pointer-events-none">
    //         {[...Array(30)].map((_, i) => (
    //           <div
    //             key={i}
    //             className="absolute w-1 h-1 bg-white rounded-full animate-ping"
    //             style={{
    //               left: `${Math.random() * 100}%`,
    //               top: `${Math.random() * 100}%`,
    //               animationDelay: `${Math.random() * 3}s`,
    //               animationDuration: `${2 + Math.random() * 2}s`
    //             }}
    //           />
    //         ))}
    //       </div>
    //     </div>
    //   )}
    // </div>
//     <div className="relative h-full flex items-center justify-center p-2">
//   <div className={`relative w-full max-w-sm cursor-pointer  `}>
//     <div className="bg-white/80 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/30 overflow-hidden p-3 space-y-3">

//       {/* Header */}
//       <div className="flex items-center justify-between">
//         <div className="flex items-center gap-2">
//           <div className="w-7 h-7 bg-gradient-to-br from-sky-500 to-blue-600 rounded-full flex items-center justify-center">
//             <Plane size={14} className="text-white rotate-12" />
//           </div>
//           <div>
//             <h3 className="text-sm font-bold text-slate-800">WANDERSCAPE</h3>
//             <p className="text-xs text-slate-500">Luxury Getaways</p>
//           </div>
//         </div>
//         <Heart size={16} className="text-red-500 animate-pulse" />
//       </div>

//       {/* Destination Image */}
//       <div className="relative rounded-xl overflow-hidden h-32">
//         <img
//           src={destinations[currentSlide]?.image}
//           alt={destinations[currentSlide]?.name}
//           className="w-full h-full object-cover"
//         />
//         <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-2">
//           <h4 className="text-white font-semibold text-sm">{destinations[currentSlide]?.name}</h4>
//           <p className="text-white/80 text-xs">{destinations[currentSlide]?.country}</p>
//         </div>
//       </div>

//       {/* Indicators */}
//       <div className="flex justify-center gap-1">
//         {destinations.map((_, index) => (
//           <span
//             key={index}
//             className={`w-1.5 h-1.5 rounded-full ${index === currentSlide ? 'bg-white' : 'bg-white/50'}`}
//           />
//         ))}
//       </div>

//       {/* Features */}
//       <div className="grid grid-cols-2 gap-2 text-xs text-slate-700">
//         <div className="flex items-center gap-1">
//           <Camera size={14} className="text-sky-600" />
//           Photo Spots
//         </div>
//         <div className="flex items-center gap-1">
//           <Calendar size={14} className="text-sky-600" />
//           Quick Date Access
//         </div>
//         <div className="flex items-center gap-1">
//           <MapPin size={14} className="text-sky-600" />
//           50+ Destinations
//         </div>
//         <div className="flex items-center gap-1">
//           <Star size={14} className="text-yellow-400" />
//           5-Star Rated
//         </div>
//       </div>

//       {/* CTA */}
//       <button className="w-full bg-gradient-to-r from-sky-500 to-blue-600 text-white font-semibold py-2 rounded-lg shadow-md hover:from-sky-600 hover:to-blue-700 transition duration-300 transform hover:scale-105">
//         <div className="flex items-center justify-center gap-2">
//           <Globe size={16} />
//           <span className="text-sm">Plan My Escape</span>
//         </div>
//       </button>

//       {/* Price Info */}
//       <div className="text-center text-xs text-slate-600">
//         Luxury packages starting from <span className="font-semibold text-sky-600">{destinations[currentSlide]?.price}</span><br />
//         <span className="text-red-500">Only 3 trips left for August</span>
//       </div>
//     </div>

//     {/* Click indicator */}
//     {showInteraction && !isAnimating && !isInPreview && (
//       <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 animate-bounce">
//         <div className="bg-black/70 text-white px-3 py-1 rounded-full text-xs">Tap to Explore</div>
//       </div>
//     )}
//   </div>
// </div>
<div className="w-full max-w-sm mx-auto relative group">
  {/* Glowing background hover effect */}
  {/* <div className="absolute -inset-1 rounded-3xl bg-gradient-to-br from-indigo-500 via-sky-500 to-purple-500 blur-xl opacity-60 group-hover:opacity-90 transition duration-700"></div> */}
  <div className="absolute -inset-1 rounded-3xl  blur-xl opacity-60 group-hover:opacity-90 transition duration-700"></div>

  {/* Main Card */}
  <div className="relative bg-gradient-to-br from-slate-800 via-slate-900 to-slate-950 text-white rounded-3xl shadow-2xl overflow-hidden p-3 transition-all duration-500  z-10">

    {/* Header */}
    <div className="mb-1 text-center space-y-1">
      <h2 className="text-sm font-semibold text-blue-300">WANDERSCAPE</h2>
      <h1 className="text-md font-bold leading-tight tracking-tight">
        UNCOVER THE WORLD’S<br />MOST BEAUTIFUL SECRETS
      </h1>
      <p className="text-xs text-slate-300">Escape like never before.</p>
    </div>

    {/* Image with Overlay Text */}
    <div className="relative rounded-xl overflow-hidden shadow-xl mb-1">
      <img
        src={destinations[currentSlide]?.image}
        alt={destinations[currentSlide]?.name}
        className="w-full h-36 object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex flex-col justify-end p-3">
        <h4 className="text-white font-bold text-base">{destinations[currentSlide]?.name}</h4>
        <p className="text-white/80 text-sm">{destinations[currentSlide]?.country}</p>
      </div>
      <div className="absolute top-2 right-2 bg-white/80 backdrop-blur-sm p-1 rounded-full shadow-md">
        <Heart className="text-red-500 w-4 h-4" />
      </div>
    </div>

    {/* Features Grid */}
    <div className="grid grid-cols-2 gap-2 text-xs text-white/90 mb-2 px-4 mt-2">
      <div className="flex items-center gap-1">
        <Camera size={14} className="text-white" />
        Photo Spots
      </div>
      <div className="flex items-center gap-1">
        <Star size={14} className="text-yellow-400" />
        5-Star Rated
      </div>
      <div className="flex items-center gap-1">
        <MapPin size={14} className="text-white" />
        50+ Locations
      </div>
      
      <div className="flex items-center gap-1">
        <Calendar size={14} className="text-white" />
        Flexible Dates
      </div>
    </div>

    {/* CTA Button */}
    <button className="w-full bg-gradient-to-r from-sky-500 to-indigo-600 text-white font-bold py-1 rounded-xl shadow-md hover:from-sky-600 hover:to-indigo-700 transition duration-300 transform hover:scale-105">
      <div className="flex items-center justify-center gap-1">
        <Plane size={16} className="rotate-12" />
        <span className="text-sm">PLAN MY ESCAPE</span>
      </div>
    </button>

    {/* Price Info */}
    <div className="text-center mt-2 text-xs text-slate-400">
      Luxury packages from <span className="font-semibold text-blue-300">{destinations[currentSlide]?.price}</span><br />
      <span className="text-red-300 font-medium">Only 3 trips left for August</span>
    </div>
  </div>
</div>

  );
};

function App() {
  const [isMobile, setIsMobile] = useState(true);

  return (
    <>
     <Helmet>
       <title>
  Travel Ad Campaigns | Blinds Category Showcase by Bidbox
        </title>
        <meta
          name="description"
          content="See how Travel ads perform in the Blinds category with Bidbox. Explore campaign strategies, creatives & insights that drive audience engagement."
        />
        {/* <meta
          name="keywords"
          content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/blinds/travel"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
    <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-4 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Back to Ad Gallery */}
              <div className="mb-6 lg:mb-8">
                {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
                  <ArrowLeft className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform duration-200" />
                  <span className="text-sm font-medium">Back to Ad Gallery</span>
                </button> */}
              </div>

              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  See the World Move With You
                  
                  </h1>
                  <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                    Blinds
                  </span>
                </div>
                
                {/* View in preview site */}
                {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
                  <Eye className="w-4 h-4" />
                  <span className="text-sm font-medium group-hover:underline">View in preview site</span>
                </button> */}
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                MAKE IT DYNAMIC
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">

                This interactive ad lets your audience travel through visuals, based on the viewer’s chosen destinations. From the Swiss Alps to Tokyo’s neon streets, each slide transitions smoothly, showcases stunning visuals and CTAs, turning one ad slot into a rotating travel experience. Just add your assets and go live.
                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
                </Link>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
                  {/* Preview toggle */}
                  <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
                  <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    {/* <span className="text-sm text-gray-600 font-medium">Preview in:</span> */}
                    <div className="flex items-center space-x-3">
                      <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                      </button>
                      <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs ">
                  {/* iPhone mockup */}
                  <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          publisher.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                        {/* Travel Ad - Full width on mobile */}
                        <div className="space-y-3">
                    <div className="h-3 bg-gray-200 rounded w-full"></div>
                    <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                    <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                  </div>
                        <div className="mb-4 mt-2">
                          <div className="relative group cursor-pointer transform transition-all duration-300  rounded-lg overflow-hidden">
                            <TravelAdContent 
                              isInPreview={true} 
                            />
                          </div>
                        </div>

                        {/* Additional content placeholders */}
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                      </div>

                     
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup - Updated to look more realistic */}
              {!isMobile && (
                <div className="w-full max-w-2xl mx-auto">
                  {/* Desktop Screen Frame */}
                  {/* <div className="bg-gray-200 rounded-md p-2 shadow-2xl"> */}
                    {/* Monitor bezel */}
                    <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                      {/* Screen */}
                      <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                        {/* macOS-style window header */}
                        <div className="bg-gray-100 px-1 py-1 flex items-center border-b border-gray-200">
                          <div className="flex space-x-2">
                            <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                            <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                          </div>
                          <div className="flex-1 mx-6">
                            <div className="bg-white rounded-md px-1 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                              🔒 publisher.com
                            </div>
                          </div>
                          <div className="flex space-x-1">
                            <div className="w-4 h-4 bg-gray-300 rounded"></div>
                            <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          </div>
                        </div>

                        {/* Browser content area */}
                        <div className="p-1 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                          {/* Page header */}
                          <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>

                          </div>

                          {/* Travel Ad positioned in content */}
                          <div className="flex justify-center mb-14">
                            <div className=" w-full">
                              <TravelAdContent 
                                isInPreview={true} 
                              />
                            </div>
                          </div>

                          {/* Additional content placeholders */}
                          <div className="grid grid-cols-2 gap-6 mb-6">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                        </div>
                      </div>
                    </div>
                  {/* </div> */}
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}

        
            </div>
          </div>
        </div>
      </div>
    </div>

   
<div className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {/* Card 1 */}
        <Link to="/ad1" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
          <img
            src="/assets/sc.avif"
            alt="Card 1"
            className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
            <h2 className="text-lg font-semibold">Scratch TO Win</h2>
          </div>
        </Link>

        {/* Card 2 */}
        <Link to="/swipe-to-reveal/pizza" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
          <img
            src="/assets/sw.jpg"
            alt="Card 2"
            className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
            <h2 className="text-lg font-semibold">Swipe to Reveal</h2>
          </div>
        </Link>

        {/* Card 3 */}
        <Link to="/tap-to-reveal/thumsup" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
          <img
            src="/assets/tmmm.png"
            alt="Card 3"
            className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
            <h2 className="text-lg font-semibold">Tap to Reveal</h2>
          </div>
        </Link>

        {/* Card 4 */}
        <Link to="/interactive-selector/travel-ramadan" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
          <img
            src="/assets/du.jpg"
            alt="Card 4"
            className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
            <h2 className="text-lg font-semibold">Dubai Travel</h2>
          </div>
        </Link>

       
      </div>
    </div>

</>



 
  );
}

export default App;